'use client'

import { Building2 } from 'lucide-react'
import { ListEmpty } from '@/components/ui/ListEmpty'

// ============================================================================
// Пустой каталог (rt6bGzJS). `CompaniesListing` — серверный компонент, а
// `ListEmpty` — клиентский: иконку-функцию через эту границу передать нельзя,
// React отказывал, и любой пустой результат каталога отдавал 500 «Произошла
// ошибка». Иконка живёт здесь, по ту сторону границы; сервер передаёт только
// строку и признак поиска.
// ============================================================================

export function CompaniesEmpty({ title, filtered }: { title: string; filtered: boolean }) {
  return <ListEmpty icon={Building2} variant={filtered ? 'filtered' : 'none'} title={title} />
}
